import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import WhoTooltipWrapper from './WhoTooltipWrapper';
import s from './Stat.scss';
const Stat = ({ deviation, onlyNumbers: showOnlyNumbers, statNameLocaleKey, statCount = 0, userListType, biData, className, icon: Icon, onClick })=>{
    const { t } = useTranslation();
    const onlyNumbers = !statNameLocaleKey || showOnlyNumbers;
    const hasTooltip = userListType && deviation;
    const iconAndStat = /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread_props(_object_spread({
        className: s['stat-button'],
        biData: biData,
        onClick: onClick
    }, onClick ? {
        style: {
            cursor: 'pointer'
        }
    } : {
        tabIndex: -1
    }), {
        isFakeButton: !onClick
    }), Icon && /*#__PURE__*/ React.createElement(Icon, {
        className: s['stat-icon'],
        size: IconSize.SMALL,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['stat-text']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['stat-count']
    }, shortenNumber(statCount)), ' ', /*#__PURE__*/ React.createElement("span", {
        className: s['stat-name']
    }, statCount === 1 ? t(`${statNameLocaleKey}_one`) : t(`${statNameLocaleKey}_other`))));
    return /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['stat'], hasTooltip && s['has-tooltip'], onlyNumbers && s['only-numbers'], className)
    }, userListType && deviation ? // TODO: there should be a way to open these with the keyboard
    /*#__PURE__*/ React.createElement(WhoTooltipWrapper, {
        deviation: deviation,
        userListType: userListType
    }, iconAndStat) : iconAndStat);
};
Stat.displayName = 'Stat';
export default Stat;

//# sourceMappingURL=Stat.js.map